<template>
  <el-dialog
    title="编辑菜单"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    :close-on-click-modal="false"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <!-- 父级菜单选择 -->
      <el-form-item label="父级菜单" prop="parent_id">
        <el-tree
          ref="menuTree"
          :data="menuTree"
          :props="treeProps"
          node-key="id"
          default-expand-all
          highlight-current
          :expand-on-click-node="false"
          :filter-node-method="filterSelfNode"
          class="menu-tree"
          :class="{ 'is-disabled': isParentSelectDisabled }"
          @node-click="handleNodeClick" 
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="data.isRoot" style="color: #999; font-size: 12px; margin-left: 8px">(顶级菜单)</span>
          </span>
        </el-tree>

        <!-- type=3 时提示 -->
        <p v-if="isParentSelectDisabled" style="color: #999; font-size: 12px; margin-top: 8px;">
          按钮类型不可更改父级
        </p>
      </el-form-item>

      <!-- 菜单名称 -->
      <el-form-item label="菜单名称" prop="menu_name">
        <el-input v-model.trim="dataForm.menu_name" placeholder="请输入菜单名称"></el-input>
      </el-form-item>

      <!-- 菜单类型 -->
      <el-form-item label="菜单类型" prop="type">
        <el-radio-group v-model="dataForm.type" @change="handleTypeChange">
          <el-radio :label="1">目录</el-radio>
          <el-radio :label="2">菜单</el-radio>
          <el-radio :label="3">按钮</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 排序 -->
      <el-form-item label="显示排序" prop="display_order">
        <el-input-number
          v-model="dataForm.display_order"
          :min="0"
          :max="999"
          placeholder="排序值越小越靠前"
          style="width: 100%"
        />
      </el-form-item>

      <!-- 路由路径 -->
      <el-form-item
        label="路由路径"
        prop="url_path"
        :rules="[
          { required: dataForm.type === 2, message: '菜单类型必须填写路由路径', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model.trim="dataForm.url_path"
          placeholder="如：/system/user，菜单类型必填"
        />
      </el-form-item>

      <!-- 权限标识 -->
      <el-form-item
        label="权限标识"
        prop="perms"
        :rules="[
          { required: dataForm.type === 3, message: '按钮类型必须填写权限标识', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model.trim="dataForm.perms"
          placeholder="如：system:user:add，按钮类型必填"
        />
      </el-form-item>

      <!-- 状态 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 显示状态 -->
      <el-form-item label="显示状态" prop="visible">
        <el-radio-group v-model="dataForm.visible">
          <el-radio :label="0">显示</el-radio>
          <el-radio :label="1">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注信息" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          v-model="dataForm.remark"
          placeholder="请输入备注信息"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditMenu',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      editId: null,

      dataForm: {
        parent_id: null,
        menu_name: '',
        type: 2,
        display_order: 0,
        url_path: '',
        perms: '',
        status: 0,
        visible: 0,
        remark: ''
      },

      dataRule: {
        menu_name: [
          { required: true, message: '菜单名称不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择菜单类型', trigger: 'change' }
        ],
        display_order: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        parent_id: [
          {
            validator: (rule, value, callback) => {
              if (this.dataForm.type === 3 && value === null) {
                callback(new Error('按钮必须挂载在某个菜单下'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      },

      menuTree: [],
      treeProps: {
        children: 'children',
        label: 'name'
      }
    };
  },

  computed: {
    isParentSelectDisabled() {
      return this.dataForm.type === 3;
    }
  },

  watch: {
    // 监听类型变化，防止误操作
    'dataForm.type'(newVal) {
      if (newVal === 3 && this.dataForm.parent_id === null) {
        this.$message.warning('按钮类型必须选择一个父级菜单');
      }
    }
  },

  methods: {
    loadMenuTree() {
      return this.$axios
        .get('/api-30216/api/menu/tree')
        .then(res => {
          const data = res.data || [];
          this.menuTree = [
            {
              id: '__root',
              name: '顶级菜单',
              isRoot: true,
              children: Array.isArray(data) ? data : []
            }
          ];
          return Promise.resolve(data);
        })
        .catch(err => {
          console.error('加载菜单树失败：', err);
          this.$message.error('无法加载菜单结构');
          this.menuTree = [];
          return Promise.reject(err);
        });
    },

    openDialog(menuId) {
      if (!menuId || !menuId.id) {
        this.$message.error('缺少菜单ID');
        return;
      }

      this.editId = menuId.id;
      this.dialogVisible = true;

      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();
      });

      this.loadMenuTree()
        .then(() => {
          return this.$axios.get(`/api-30216/api/menu/${this.editId}`);
        })
        .then(res => {
          const responseData = res.data;
          const menu = responseData && responseData.data != null ? responseData.data : responseData;

          if (!menu) {
            this.$message.error('未获取到菜单信息');
            this.dialogVisible = false;
            return;
          }

          this.dataForm = {
            parent_id: menu.parent_id,
            menu_name: menu.menu_name || '',
            type: menu.type,
            display_order: menu.display_order || 0,
            url_path: menu.url_path || '',
            perms: menu.perms || '',
            status: menu.status != null ? menu.status : 0,
            visible: menu.visible != null ? menu.visible : 0,
            remark: menu.remark || ''
          };

          this.$nextTick(() => {
            // 触发过滤，隐藏非法节点
            this.$refs.menuTree.filter(null);
            // 设置当前选中节点
            const key = this.dataForm.parent_id === null ? '__root' : this.dataForm.parent_id;
            this.$refs.menuTree.setCurrentKey(key);
          });
        })
        .catch(err => {
          this.$message.error('加载菜单详情失败');
          console.error(err);
          this.dialogVisible = false;
        });
    },

    resetForm() {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields();
      }
      this.editId = null;
    },


    handleNodeClick(data) {
      // 在方法内部判断是否允许选择
      if (this.isParentSelectDisabled) {
        return; // 按钮类型禁止更改父级
      }

      const key = data.id === '__root' ? null : data.id;

      if (key === this.editId) {
        this.$message.warning('不能选择自身作为父级');
        return;
      }

      if (this.isChildNode(key, this.editId)) {
        this.$message.warning('不能选择子级作为父级');
        return;
      }

      if (data.type === 3) {
        this.$message.warning('不能选择按钮作为父级菜单');
        return;
      }

      this.dataForm.parent_id = key;
      this.$refs.menuTree.setCurrentKey(data.id);

      console.log('✅ 已设置 parent_id:', key);
    },

    isChildNode(targetId, childId) {
      const findInChildren = (nodes, child) => {
        for (const node of nodes || []) {
          if (node.id === child) return true;
          if (findInChildren(node.children, child)) return true;
        }
        return false;
      };

      const findInTree = (nodes, target, child) => {
        for (const node of nodes || []) {
          if (node.id === target) {
            return !!findInChildren(node.children, child);
          }
          if (findInTree(node.children, target, child)) {
            return true;
          }
        }
        return false;
      };

      return findInTree(this.menuTree, targetId, childId);
    },

    filterSelfNode(value, data) {
      if (!this.editId) return true;
      if (data.id === this.editId) return false;
      if (data.type === 3) return false;
      return !this.isChildNode(data.id, this.editId);
    },

    handleTypeChange(val) {
      if (val === 3 && this.dataForm.parent_id === null) {
        this.$message.warning('按钮类型必须选择一个父级菜单');
      }
    },

    findNodeById(nodes, id) {
      for (const node of nodes || []) {
        if (node.id === id) return node;
        const found = this.findNodeById(node.children, id);
        if (found) return found;
      }
      return null;
    },

    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return;

        // 防御性校验：检查 parent_id 是否指向按钮
        if (this.dataForm.parent_id !== null) {
          const parent = this.findNodeById(this.menuTree, this.dataForm.parent_id);
          if (parent && parent.type === 3) {
            this.$message.error('不能将按钮作为父级菜单');
            return;
          }
        }

        const postData = {
          ...this.dataForm,
          id: this.editId
        };

        this.submitLoading = true;
        this.$axios
          .put(`/api-30216/api/menu/${this.editId}`, postData)
          .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200 || responseData.success) {
              this.$message.success('更新成功');
              this.dialogVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(responseData.message || '更新失败');
            }
          })
          .catch(err => {
            let msg = '更新菜单失败';
            if (err.response && err.response.data && err.response.data.message) {
              msg = err.response.data.message;
            } else if (err.message) {
              msg = err.message;
            }
            this.$message.error(msg);
            console.error('提交错误：', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
 align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.el-tree {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
}

.menu-tree.is-disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>